import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "./Button";

export const PageHeader = ({
  title,
  description,
  backTo,
  onBack,
  backLabel = "Back",
  actions,
  className = "",
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  const showBackButton = Boolean(backTo || onBack);

  return (
    <div
      className={`flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-2 ${className}`}
    >
      <div className="flex items-center gap-3">
        {showBackButton && (
          <Button
            variant="secondary"
            size="sm"
            onClick={handleBack}
            leftIcon={<ArrowLeft className="w-4 h-4" />}
          >
            {backLabel}
          </Button>
        )}
        <div>
          <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-gray-900 dark:text-neutral-100">
            {title}
          </h1>
          {description && (
            <p className="text-xs sm:text-sm text-gray-500 dark:text-neutral-400 mt-0.5">
              {description}
            </p>
          )}
        </div>
      </div>

      {actions && (
        <div className="flex items-center gap-2 flex-wrap self-start sm:self-auto">
          {actions}
        </div>
      )}
    </div>
  );
};